import React, { useEffect, useState, useCallback } from 'react';
import idtap from './Icons/ID-tap.jpg';
import { useHistory } from 'react-router-dom';
import HelloRegister from './helloRegister';
import Swal from 'sweetalert2';
import request from '../../../services/Request';
import PingPad from '../../items/Pingpad';
import localRequest from '../../../services/LocalServer/localRequest';
import logger from '../../../services/LocalServer/logger';

export default function ScanPage(props) {
  const homepage = localStorage.getItem('homepage');
  const history = useHistory();
  // const machineID = localStorage.getItem('machineID');
  //use to prevent add event listener multitple times
  const { setLoading, setHFuser, setProds } = props;

  const [success, setSuccess] = useState(0);
  const [error, setError] = useState(0);
  const [notvalid, setNotValid] = useState(false);
  const [show, setShow] = useState(false);

  const openModal = () => {
    setShow(true);
  };

  const login = async (barcode) => {
    request({
      method: 'POST',
      url: '/users/hf/getUser',
      data: {
        id: barcode,
      },
    })
      .then((res) => {
        console.log('res', res.data);
        let userCate = res.data.categories;
        setHFuser({
          hfid: res.data.hfid,
          _id: res.data._id,
        });
        let category = JSON.parse(localStorage.getItem('category'));
        const products = JSON.parse(localStorage.getItem('products'));

        // Iterate through array1
        for (const item1 of userCate) {
          // Find corresponding item in array2 by _id
          const matchingItem2 = category.find((item2) => item2._id === item1.category);

          // Update limit in array2 if a match is found
          if (matchingItem2) {
            matchingItem2.limit -= item1.quantity;
            console.log('matchingItem2', matchingItem2);
          }
        }

        // const { result, limitCategories } = updateLimits(userCate, category);
        console.log('category', category);
        console.log('userCate', userCate);
        localStorage.setItem('category', JSON.stringify(category));

        products.forEach((pd) => {
          if (pd.category) {
            const findIndex = category.findIndex((cate) => cate._id === pd.category[0]);
            if (findIndex > -1) {
              pd.limit = category[findIndex].limit;
              if (pd.current_stock > pd.limit) {
                pd.current_stock = pd.limit;
              }
            }
          }
        });
        console.log('products', products);
        // localStorage.setItem('products', JSON.stringify(products));
        setProds(products);

        Swal.fire({
          icon: 'success',
          title: 'Login successfully!',
          timer: 2000,
        }).then(() => {
          history.push(homepage);
        });
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Login failed!',
          html: err?.response?.data?.message,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.hideLoading();
          },
        });
      });
  };

  const handlepinpad = async (ping) => {};

  // useEffect(() => {
  //   let barcode = '';
  //   let interval;
  //   let preDate = new Date();

  //   const readBarcode = (evt) => {
  //     if (interval) {
  //       clearInterval(interval);
  //     }

  //     if (evt.code === 'Enter') {
  //       if (barcode) handleBarcode(barcode, preDate);
  //       barcode = '';
  //       return;
  //     }
  //     if (evt.code !== 'Shift' && evt.code !== 'ShiftLeft' && evt.code !== 'ShiftRight') {
  //       barcode += evt.key;
  //     }
  //     interval = setInterval(() => (barcode = ''), 100);
  //     return;
  //   };

  //   document.addEventListener('keydown', readBarcode);

  //   const handleBarcode = async (bq, pre) => {
  //     const nowDate = new Date();
  //     document?.activeElement?.blur();
  //     //add scan cooldown 5 seconds
  //     if (nowDate.getTime() - pre.getTime() > 2000) {
  //       preDate = nowDate;
  //       setLoading(true);
  //       await login(bq);
  //       setLoading(false);
  //     } else {
  //       Swal.fire({
  //         timer: 2000,
  //         text: 'Please wait 2 seconds before scanning again',
  //         allowOutsideClick: false,
  //         allowEscapeKey: false,
  //         allowEnterKey: false,
  //         showConfirmButton: false,
  //       });
  //     }
  //   };

  //   return () => {
  //     document.removeEventListener('keydown', readBarcode);
  //   };
  // }, []);

  return (
    <div className="main-container themeColor" style={{ background: 'rgb(235, 235, 235)' }}>
      <HelloRegister
        show={show}
        setShow={setShow}
        onHide={() => {
          setShow(false);
        }}
      />
      <div style={{ padding: '20px 40px' }}>
        <div
          onClick={() => {
            login(`6570ce296a6564e0a88515c3`);
          }}
          style={{
            fontWeight: 'bold',
            fontSize: '100px',
            paddingTop: '50px',
            marginBottom: '80px',
          }}
        >
          Welcome!
        </div>
        <div
          style={{
            fontWeight: 'bold',
            fontSize: '55px',
            marginBottom: '30px',
            marginTop: '10px',
          }}
        >
          <span> To begin please scan your QR code </span>
        </div>
        {/* <img src={idtap} alt="i2" width={800} /> */}
        <PingPad show={true} setShow={setShow} run={handlepinpad} />
        <div
          style={{
            fontWeight: 'bold',
            fontSize: '55px',
            marginBottom: '20px',
            marginTop: '10px',
          }}
        >
          <div> To register please click the button below</div>
          <div className="hf-button" onClick={openModal}>
            Register
          </div>
        </div>
      </div>
    </div>
  );
}
